import { Component, HostListener, ChangeDetectionStrategy, inject } from '@angular/core';
import { RealEstateReport } from '@eadsysteme/energyefficiencyclient-v1';
import { MAT_DIALOG_DATA, MatDialogRef, MatDialogActions } from '@angular/material/dialog';
import { TranslocoDirective } from '@jsverse/transloco';
import { CdkDrag, CdkDragHandle } from '@angular/cdk/drag-drop';
import { MatIconButton, MatButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import AppendixSendingOptionsEnum = RealEstateReport.AppendixSendingOptionsEnum;

@Component({
	selector: 'vex-appendix-dialog',
	templateUrl: './appendix-dialog.component.html',
	styleUrls: ['./appendix-dialog.component.scss'],
	changeDetection: ChangeDetectionStrategy.Eager,
	imports: [
		TranslocoDirective,
		CdkDrag,
		MatIconButton,
		MatIcon,
		CdkDragHandle,
		MatRadioGroup,
		ReactiveFormsModule,
		FormsModule,
		MatRadioButton,
		MatDialogActions,
		MatButton,
	],
})
export class AppendixDialogComponent {
	dialogRef = inject<MatDialogRef<AppendixDialogComponent>>(MatDialogRef);
	data = inject(MAT_DIALOG_DATA, { optional: true });

	selectedAppendixOption: any;
	appendixOptions: string[] = Object.values(AppendixSendingOptionsEnum);

	doAction() {
		this.dialogRef.close({ event: 'save', data: this.selectedAppendixOption });
	}

	closeDialog() {
		this.dialogRef.close({ event: 'cancel' });
	}

	@HostListener('document:keydown.escape', ['$event'])
	onEscapeKey(event: Event): void {
		event.preventDefault();
		this.closeDialog();
	}
}
